import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useConnectPostgresqlMutation } from "./sql/sqlApiSlice";

const inputFields = [
    { label: "Host", name: "host", type: "text" },
    { label: "Port", name: "port", type: "text" },
    { label: "Database Type", name: "databaseType", type: "text" },
    { label: "Username", name: "user", type: "text" },
    { label: "Password", name: "password", type: "password" },
    { label: "Database", name: "database", type: "text" },
];

const Connectionpgform = ({ closeModal }) => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        databaseType: "postgresql",
        host: "122.176.146.28",
        user: "postgres",
        password: "Samepassword1!",
        port: "1234",
        database: "vizlabs"
    });

    const [connectPG, { data, isError, isSuccess, isLoading, error }] = useConnectPostgresqlMutation();

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        connectPG(formData);
    };

    useEffect(() => {
        if (isSuccess && data?.connectionId && Array.isArray(data?.tables)) {
            const timer = setTimeout(() => {

                navigate(`/dataconfigure?connectionId=${data.connectionId}`, {
                    state: {
                        response: [formData.database], // PostgreSQL returns single DB
                        tables: data.tables,
                        dbType: formData.databaseType
                    },
                });
            }, 800);
            return () => clearTimeout(timer);
        }
    }, [isSuccess, data, navigate, formData.database, formData.databaseType]);

    return (
        <>
            <form onSubmit={handleFormSubmit} className="flex flex-col gap-2 w-full items-center justify-start">
                {inputFields.map(({ label, name, type }) => (
                    <div key={name} className="flex flex-col w-full px-2 gap-1 text-left">
                        <label htmlFor={name} className="font-medium">
                            {label}
                        </label>
                        <input
                            type={type}
                            name={name}
                            value={formData[name]}
                            onChange={handleInputChange}
                            className="border border-gray-200 rounded px-2 py-0 w-full text-base focus:outline-none"
                            required
                        />
                    </div>
                ))}
                <div className="flex w-full p-2 gap-2 items-center justify-end">
                    <button type="button" onClick={closeModal} className="border py-1 px-4 text-gray-700 hover:bg-gray-200">
                        Cancel
                    </button>
                    <button type="submit" disabled={isLoading} className="border py-1 px-4 text-white bg-blue-950 hover:bg-blue-800 disabled:opacity-50">
                        {isLoading ? "Connecting..." : "Connect"}
                    </button>
                </div>
            </form>

            {isSuccess && (
                <div className="text-green-600 text-center mt-2">
                    {data?.message || "Connected!"}
                </div>
            )}

            {isError && (
                <div className="text-red-600 text-center mt-2">
                    {error?.data?.message?.error || error?.data?.error}
                </div>
            )}
        </>
    );
};

export { Connectionpgform };
